<template>
  <div class="order-success">
    <!-- <headerTop /> -->
    <div class="content">
      <div>
        <eProcess :process-data="processData" :is-active="1"></eProcess>
      </div>

      <!-- <div class="header">
        <div class="left">
          <img src="~/assets/images/logo2.png" alt="" />
          <div>创建询价单成功</div>
        </div>
        <div class="right">
          <ul>
            <li v-for="item in 3">
              <div class="top">
                <span class="content">{{ item }}</span>
              </div>
              <div class="bottom">
                {{
                  item == 1
                    ? "确认商品信息"
                    : item == 2
                    ? "确认订单信息"
                    : "完成"
                }}
              </div>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="main">
        <div class="success">{{ saveFlag === '0' ? '询价单保存成功' : '创建询价单成功' }}</div>
        <img :src="img" alt="" />
        <div class="operate">
          <div>
            {{ saveFlag === '0' ? '' : '询价发起成功，请耐心等待供应商反馈，' }}您可以
            <span class="important cursor" @click="seeOrder">查看询价单</span>
            或
            <span class="important cursor" @click="continueShopping">继续询价</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EProcess from '@/modules/projectA/components/common/e-process.vue';

export default {
  name: 'OrderSuccess',
  components: { /* headerTop, Footer, */ EProcess },
  data() {
    return {
      img: require('@/assets/img/enquiry/robot.png'),
      processData: [
        { itemName: '发布询价需求', title: '发布询价需求', tip: '', description: '', icon: '' },
        { itemName: '供应企业报价', title: '供应企业报价', tip: '', description: '', icon: '' },
        { itemName: '选商定价', title: '选商定价', tip: '', description: '', icon: '' },
        { itemName: '结果公示', title: '结果公示', tip: '', description: '', icon: '' },
      ],
      saveFlag: '',
    };
  },
  /*
您可以 查看询价单 或 继续询价 */
  mounted() {
    this.saveFlag = this.$route.query.saveFlag || '';
  },
  methods: {
    seeOrder() {
      this.$router.push({ path: '/emergencyEnquiry/enquiryManage' });
    },
    continueShopping() {
      this.$router.push({ path: '/emergencyEnquiry/enquiryIss' });
    },
  },
};
</script>

<style scoped lang="scss">
.order-success {
  width: 100%;
  padding: 20px;
  background: #fff;
  .content {
    width: 1200px;
    margin: 10px auto 80px;
    font-style: normal;
    font-weight: normal;
    .header {
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        height: 49px;
        align-items: center;
        img {
          width: 100px;
          margin-right: 20px;
        }
        div {
          height: 38px;
          line-height: 38px;
          padding-left: 20px;
          border-left: 1px solid #333;
          font-size: 24px;
        }
      }
      .right {
        ul {
          display: flex;
          li {
            width: 240px;
            height: 4px;
            background: #2587ff;
            margin: 10px 2px 0 0;
            position: relative;
            .top {
              position: absolute;
              width: 24px;
              height: 24px;
              line-height: 24px;
              border-radius: 50%;
              left: 50%;
              top: -12px;
              background: #2587ff;
              color: #fff;
              text-align: center;
              z-index: 9999;
            }
            .bottom {
              text-align: center;
              margin: 20px 0 0 22px;
              color: #2587ff;
            }
            &:last-child,
            &:last-child .top {
              background: #2587ff;
            }
            &:last-child .bottom {
              color: #2587ff;
            }
            &:not(:first-child)::before {
              position: absolute;
              content: '';
              width: 0;
              height: 0;
              border: 2px solid transparent;
              border-left-color: #fff;
            }
            &:not(:first-child)::after {
              top: 0;
              left: -2px;
              position: absolute;
              content: '';
              width: 0;
              height: 0;
              border: 2px solid transparent;
              border-left-color: #2587ff;
            }
          }
        }
      }
    }
    .main {
      margin-top: 90px;
      text-align: center;
      color: #000;
      .success {
        font-size: 24px;
        margin-bottom: 20px;
      }
      img {
        width: 160px;
        height: 160px;
      }
      .operate {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        font-size: 18px;
        .important {
          color: #2587ff;
          &:hover {
            border-bottom: 1px solid #2587ff;
          }
        }
        .cursor {
          cursor: pointer;
        }
        .button {
          margin-left: 50px;
          display: flex;
          div {
            border-bottom: 1px solid #2587ff;
          }
          div:last-child {
            margin-left: 30px;
          }
        }
      }
    }
  }
}
</style>
